import PropTypes from "prop-types";

import AssignButton from "@/components/AssignButton";
import BookmarkButton from "@/components/BookmarkButton";
import useUser from "@/users/useUser";
import { cardFooterCss, cardFooterCssNoAssignButton } from "./CardFooter.style";

const propTypes = {
  assignmentsDerivedFromViewPage: PropTypes.arrayOf(PropTypes.object),
  assignments: PropTypes.arrayOf(PropTypes.object),
  /* content_id derived from the V3 Content API */
  contentId: PropTypes.string,
  contentIds: PropTypes.array,
  /* content_type derived from the V3 Content API */
  contentType: PropTypes.string,
  /* recommendation_set_ids from content API */
  recommendationSetIds: PropTypes.arrayOf(PropTypes.string),
  renderAssignButton: PropTypes.bool,
  streamProperties: PropTypes.object,
  veil: PropTypes.object,
  visibilityMarkers: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  contentId: "",
  contentIds: [],
  contentType: "",
  recommendationSetIds: [],
  renderAssignButton: true,
  veil: {},
};

const CardFooter = ({
  assignmentsDerivedFromViewPage,
  assignments,
  contentId,
  contentIds,
  contentType,
  recommendationSetIds,
  renderAssignButton,
  streamProperties,
  visibilityMarkers,
  veil,
}) => {
  const { data: user } = useUser();

  const maybeContentIds = contentIds.length > 0 ? contentIds : false;

  const contentWithAdvisory = veil?.reason === "DISTRICT_ADVISORY";

  if (!user?.is_authenticated) {
    return <></>;
  }
  const isStandard = contentType === "standard";
  const cardFooterStyles = renderAssignButton
    ? cardFooterCss
    : cardFooterCssNoAssignButton;

  const assignButton = renderAssignButton && (
    <AssignButton
      assignmentsDerivedFromViewPage={
        assignments || assignmentsDerivedFromViewPage
      }
      contentId={contentId}
      contentIds={maybeContentIds}
      contentType={contentType}
      recommendationSetIds={recommendationSetIds}
      contentWithAdvisory={contentWithAdvisory}
      streamProperties={streamProperties}
      visibilityMarkers={visibilityMarkers}
    />
  );

  const bookmarkButton = !isStandard && (
    <BookmarkButton contentId={contentId} streamProperties={streamProperties} />
  );

  return (
    <div css={cardFooterStyles}>
      {assignButton}
      {bookmarkButton}
    </div>
  );
};

CardFooter.defaultProps = defaultProps;
CardFooter.propTypes = propTypes;
export default CardFooter;
